import { render, staticRenderFns } from "./UWCProfile.vue?vue&type=template&id=35d46a01&scoped=true&"
import script from "./UWCProfile.vue?vue&type=script&lang=js&"
export * from "./UWCProfile.vue?vue&type=script&lang=js&"
import style0 from "./UWCProfile.vue?vue&type=style&index=0&id=35d46a01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d46a01",
  null
  
)

export default component.exports